import { render, staticRenderFns } from "./ImageHoverable.vue?vue&type=template&id=8d2ad674&"
import script from "./ImageHoverable.vue?vue&type=script&lang=js&"
export * from "./ImageHoverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports